exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na.btn[data-v-79551633] {\n    color: white;\n    cursor: pointer;\n}\na.btn[data-v-79551633]:hover {\n    color: white;\n}\n", ""]);

// exports
